export default __webpack_public_path__ + "static/media/hdfc.001dca55.png";